export const isDevEnv = () => {
    const urlHost = window.location.host?.toLowerCase();
    return urlHost?.includes("dev.moodys.com");
};
//# sourceMappingURL=isDevEnv.js.map